/* eslint-disable func-style */
/**
 * Easing Functions - inspired from http://gizma.com/easing/
 */

/**
 * no easing, no acceleration
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function linear(time, begin, change, duration) {
  return change * time / duration + begin;
}

/**
 * accelerating from zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInQuad(time, begin, change, duration) {
  time /= duration;
  return change * time * time + begin;
}

/**
 * decelerating to zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeOutQuad(time, begin, change, duration) {
  time /= duration;
  return -change * time * (time - 2) + begin;
}

/**
 * acceleration until halfway, then deceleration
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInOutQuad(time, begin, change, duration) {
  time /= (duration / 2);
  if (time < 1) {
    return (change / 2) * time * time + begin;
  }
  time--;
  return (-change / 2) * (time * (time - 2) - 1) + begin;
}

/**
 * accelerating from zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInCubic(time, begin, change, duration) {
  time /= duration;
  return change * time * time * time + begin;
}

/**
 * decelerating to zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeOutCubic(time, begin, change, duration) {
  time /= duration;
  time--;
  return change * (time * time * time + 1) + begin;
}

/**
 * acceleration until halfway, then deceleration
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInOutCubic(time, begin, change, duration) {
  time /= (duration / 2);
  if (time < 1) {
    return (change / 2) * time * time * time + begin;
  }
  time -= 2;
  return (change / 2) * (time * time * time + 2) + begin;
}

/**
 * accelerating from zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInQuart(time, begin, change, duration) {
  time /= duration;
  return change * time * time * time * time + begin;
}

/**
 * decelerating to zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeOutQuart(time, begin, change, duration) {
  time /= duration;
  time--;
  return -change * (time * time * time * time - 1) + begin;
}

/**
 * acceleration until halfway, then deceleration
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInOutQuart(time, begin, change, duration) {
  time /= (duration / 2);
  if (time < 1) {
    return (change / 2) * time * time * time * time + begin;
  }
  time -= 2;
  return (-change / 2) * (time * time * time * time - 2) + begin;
}

/**
 * accelerating from zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInQuint(time, begin, change, duration) {
  time /= duration;
  return change * time * time * time * time * time + begin;
}

/**
 * decelerating to zero velocity
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeOutQuint(time, begin, change, duration) {
  time /= duration;
  time--;
  return change * (time * time * time * time * time + 1) + begin;
}

/**
 * acceleration until halfway, then deceleration
 * @param time
 * @param begin
 * @param change
 * @param duration
 * @returns {*}
 */
export function easeInOutQuint(time, begin, change, duration) {
  time /= (duration / 2);
  if (time < 1) {
    return (change / 2) * time * time * time * time * time + begin;
  }
  time -= 2;
  return (change / 2) * (time * time * time * time * time + 2) + begin;
}



// WEBPACK FOOTER //
// ./js/utils/easings.js